module.exports = __webpack_public_path__ + "img/plb3.1d7118c1.jpeg";